// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Outdoor from './Outdoor';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Outdoor);
